module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item hidden-mobile"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "hidden-sm-down"
  }, [_vm._v(_vm._s(_vm.subtitle))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a4b59e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/TopBar/Navigation/LiTitle.vue
// module id = 668
// module chunks = 1